/*
 *  Class Tarif
 */
export
default class Tarif {
    constructor() {
        this.tarif = document.querySelectorAll('.tarif');
    }

    hide(el) {
        el.classList.add('hidden');
    }

    show(el) {
        el.classList.remove('hidden');
    }

    toggleList(e) {
        e.preventDefault();
        const id = e.target.closest('a').getAttribute('for');

        const btns = e.target.closest('.tarif__header').querySelectorAll('.tarif__toggle-btn');
        for (let i = 0; i < btns.length; i++) {
            if (btns[i].getAttribute('for') === id) {
                this.hide(btns[i]);
            } else {
                this.show(btns[i]);
            }
        }

        const lists = e.target.closest('.tarif').querySelectorAll('.tarif__content .tarif__list');
        for (let i = 0; i < lists.length; i++) {
            if (lists[i].getAttribute('id') === id) {
                this.show(lists[i]);
            } else {
                this.hide(lists[i]);
            }
        }
    }

    filter(e) {
        const filter = e.target.value.toUpperCase();
        const trs = e.target.closest('.tarif').querySelectorAll('tbody tr');
        trs.forEach(tr => [ ...tr.children ].find(td => td.innerHTML.toUpperCase().includes(filter) || !filter.length) ? tr.classList.remove('hidden') : tr.classList.add('hidden'));
    }

    enableFilter(el) {
        'keyup,change'.split(',').map(name => el.addEventListener(name, this.filter.bind(this), false));
    }

    enableSort(el) {
        // Sort by header
        const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;
        const comparer = (idx, asc) => (a, b) => ((v1, v2) =>
            v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)
        )(getCellValue(asc ? a : b, idx), getCellValue(asc ? b : a, idx));
        el.querySelectorAll('th').forEach(th => th.addEventListener('click', ((e) => {
            const table = th.closest('table').querySelector('tbody');
            Array.from(table.querySelectorAll('tr:nth-child(n+1)'))
                .sort(comparer(Array.from(th.parentNode.children).indexOf(th), this.asc = !this.asc))
                .forEach(tr => table.appendChild(tr));
            for (let i = 0; i < el.querySelectorAll('th').length; i++) {
                el.querySelectorAll('th')[i].classList.remove('asc');
                el.querySelectorAll('th')[i].classList.remove('desc');
            }
            e.target.classList.add(this.asc ? 'asc' : 'desc');
        })));
    }

    handleJumpToAll(e) {
      const activeEl = e.target.closest('.tarif').querySelector('.tarif__toggle-btn:not(.hidden)');
      if (activeEl.getAttribute('data-type') === 'all') activeEl.click();
    }

    enableJumpToAll(el) {
      const input = el.querySelector('.tarif__filter-input');
      'keydown'.split(',').map(name => input.addEventListener(name, this.handleJumpToAll.bind(this), false));
    }

    init() {
        for (let i = 0; i < this.tarif.length; i++) {
            const btns = this.tarif[i].querySelectorAll('.tarif__toggle-btn');
            for (let ii = 0; ii < btns.length; ii++) {
                btns[ii].addEventListener('click', this.toggleList.bind(this));
            }
            this.enableSort(this.tarif[i]);
            this.enableFilter(this.tarif[i]);
            this.enableJumpToAll(this.tarif[i]);
        }
    }
}
